import * as React from 'react';
import style from './InputGroup.module.css';

export interface InputGroupProps {
  children: React.ReactNode;
  margin?: string;
}

export function InputGroup({ children, margin }: InputGroupProps) {
  return (
    <div className={style.groupDiv} style={{ margin }}>
      {children}
    </div>
  );
}
